import React, { useState, useEffect } from "react";
import Plotly from "plotly.js-dist";

export const MonthlyBalanceChart = (props) => {
  const maxHeight = window.innerHeight - 230;

  // set chart data for Monthly values and Hourly values
  setTimeout(() => {
    var charData = [
      {
        x: props.data.map((obj) => obj["Month"]),
        y: props.data.map((obj) => obj["pow_alt_cur"].toFixed(0)),
        type: "bar",
        name: "Production",
        hovertemplate:
          "<i>%{x}</i>" +
          "<br>Power in alternate current: %{y} MWh<extra></extra>",
      },
    ];
    // set chart layout
    var layout = {
      margin: { t: 50, b: 30, l: 60, r: 30 },
      hovermode: "closest",
      title: {
        text: "Average Monthly Energy Balances (in MWh)",
        standoff: 10,
      },
      yaxis: {
        title: {
          text: "Balance (MWh)",
          standoff: 10,
        },
      },
    };
    // make plot
    Plotly.newPlot("chartResults", charData, layout, {
      displaylogo: false,
    });
  }, 100);

  return (
    <div style={{ padding: "15px 25px 10px 25px", backgroundColor: "white" }}>
      <div
        id="chartResults"
        style={{ width: "100%", height: maxHeight, marginTop: 0 }}
      ></div>
    </div>
  );
};

export default MonthlyBalanceChart;
